import React, { useState } from 'react';

export default function AllergyAlert({ patientAllergies = '', selectedDrug = '', onConfirm, onCancel }) {
  const [overrideReason, setOverrideReason] = useState('');

  if (!selectedDrug || !patientAllergies) return null;

  const allergyList = typeof patientAllergies === 'string'
    ? patientAllergies.split(/[,;/\n]/).map(a => a.trim().toLowerCase()).filter(Boolean)
    : [];

  const drugLower = selectedDrug.toLowerCase();
  const conflict = allergyList.find(a => drugLower.includes(a) || a.includes(drugLower.split(' ')[0]));

  if (!conflict) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: 12, padding: 32, maxWidth: 480, width: '90%',
        border: '3px solid #ef4444', boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <div style={{ fontSize: 32 }}>⚠️</div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#ef4444' }}>Allergy Alert</div>
            <div style={{ fontSize: 13, color: '#6b7280' }}>Drug-Allergy Conflict Detected</div>
          </div>
        </div>
        <div style={{ backgroundColor: '#fef2f2', borderRadius: 8, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 14, color: '#991b1b' }}>
            Patient is allergic to: <strong>{conflict}</strong>
          </div>
          <div style={{ fontSize: 14, color: '#991b1b', marginTop: 4 }}>
            Selected drug: <strong>{selectedDrug}</strong>
          </div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
            Override Reason (required to proceed)
          </label>
          <textarea
            value={overrideReason}
            onChange={e => setOverrideReason(e.target.value)}
            placeholder="Document clinical reason for overriding allergy alert..."
            rows={3}
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={onCancel}
            style={{ flex: 1, padding: '10px 0', border: '1px solid #d1d5db', borderRadius: 8, backgroundColor: '#fff', cursor: 'pointer', fontSize: 14 }}
          >
            Cancel — Choose Different Drug
          </button>
          <button
            onClick={() => overrideReason.trim() && onConfirm(overrideReason)}
            disabled={!overrideReason.trim()}
            style={{
              flex: 1, padding: '10px 0', borderRadius: 8, cursor: overrideReason.trim() ? 'pointer' : 'not-allowed',
              backgroundColor: overrideReason.trim() ? '#ef4444' : '#fca5a5',
              color: '#fff', border: 'none', fontSize: 14, fontWeight: 600
            }}
          >
            Override & Prescribe
          </button>
        </div>
      </div>
    </div>
  );
}
